import classnames from "classnames";
import {format} from "date-fns-tz";
import {FaCircleArrowUp} from "react-icons/fa6";

import css from "./StatusPageThemePreview.module.css";
export interface StatusPageThemePreviewProps {
  name: string;
  timezone: string;
  textColor: string;
  backgroundColor: string;
}

const PulseIcon = () => (
  <svg
    className={classnames("mr-1", css.pulseIcon)}
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="11.5" cy="11" r="9" fill="#00AA66" />
    <circle opacity="0.25" cx="11.5" cy="11" r="8" fill="#00AA66" />
    <circle opacity="0.4" cx="11.5" cy="11" r="7" fill="#00AA66" />
    <circle cx="11.5" cy="11" r="6" fill="#00AA66" />
  </svg>
);

export const StatusPageThemePreview = ({name, timezone, textColor, backgroundColor}: StatusPageThemePreviewProps) => {
  return (
    <div className={css.previewContainer}>
      <div className={css.previewHeaderContainer}>
        <div className={css.previewHeaderHighlighted} style={{backgroundColor: backgroundColor, color: textColor}}>
          <div className={classnames("row", css.previewHeaderInner)}>
            <div className="col-6">
              <h1>{name}</h1>
              <small className="d-block">
                Timezone: ({format(new Date(), "OOOO", {timeZone: timezone})}) {timezone}
              </small>
            </div>
            <div className="col-6 px-0 d-flex align-items-center justify-content-end">
              <div className={css.subscribeButton} style={{borderColor: textColor}}>
                Subscribe
              </div>
            </div>
            <div className={classnames("mx-auto", css.globalStatusContainer, css.isOperational)}>
              <div className="row ps-2 pe-2 mt-1">
                <div className="col-8 px-0">
                  <FaCircleArrowUp className="me-2" /> All Systems Operational
                </div>
                <div className="col-4 mt-0 px-0 text-end">
                  <span className={css.globalStatusDuration}>
                    <PulseIcon /> For: <strong>1 day</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css.previewHeaderNormal}></div>
      </div>
    </div>
  );
};
